(() => {
  if (window.PYSProductQuantitySync) return;

  window.PYSProductQuantitySync = true;

  const selector = '[data-pys-product-quantity-sync]';
  let isSyncing = false;

  const normaliseValue = (input, eventType) => {
    if (eventType !== 'change' || input.value !== '') return input.value;

    input.value = input.min || input.dataset.min || '1';
    return input.value;
  };

  const updateQuantityInputState = (input) => {
    const quantityInput = input.closest('quantity-input');

    if (quantityInput && typeof quantityInput.validateQtyRules === 'function') {
      quantityInput.validateQtyRules();
    }
  };

  const syncQuantity = (source, eventType) => {
    if (isSyncing || !source?.matches(selector)) return;

    const group = source.dataset.pysProductQuantitySync;
    if (!group) return;

    const value = normaliseValue(source, eventType);
    const inputs = Array.from(document.querySelectorAll(selector)).filter(
      (input) => input.dataset.pysProductQuantitySync === group
    );

    isSyncing = true;

    inputs.forEach((input) => {
      if (input === source) {
        updateQuantityInputState(input);
        return;
      }

      input.value = value;
      updateQuantityInputState(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    isSyncing = false;
  };

  const handleQuantityEvent = (event) => {
    const source = event.target.closest(selector);
    if (!source) return;

    syncQuantity(source, event.type);
  };

  document.addEventListener('input', handleQuantityEvent);
  document.addEventListener('change', handleQuantityEvent);
})();
